import React, { useEffect } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

export const ErrorDialog: React.FC<{
  type: 'license' | 'passport'
  onClose: () => void
}> = props => {
  const { t } = useTranslation()

  useEffect(() => {
    const t = setTimeout(() => {
      props.onClose()
    }, 5000)
    return () => {
      clearTimeout(t)
    }
  }, [])

  return (
    <>
      <div css={backgroundStyle} onClick={props.onClose}></div>
      <div css={dialogStyle} onClick={props.onClose}>
        <div className="content-block">
          <img src={require('@/static/images/self-checkin-payment/terminal/icon_ng.svg')} />
          {props.type === 'passport' ? (
            <>
              <div className="-text" style={{ paddingTop: 24 }}>
                {t('Passport reading failed.')}
              </div>
              <div className="passport-instruction-block">
                <div className="title" style={{ paddingTop: 8 }}>
                  {t('passportInstruction')}
                </div>
                <div className="description" style={{ paddingTop: 8 }}>
                  ・{t('instructionMakeTextClear')}
                </div>
                <div className="description" style={{ paddingTop: 8 }}>
                  ・{t('instructionKeepFingersClear')}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="-text" style={{ paddingTop: 24 }}>
                {t('ID card not detected.')}
              </div>
              <div className="-text" style={{ paddingTop: 8 }}>
                {t('Please take another photo.')}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

const backgroundStyle = css({
  background: 'rgba(0, 0, 0, 0.5)',
  height: '100vh',
  width: '100vw',
  position: 'absolute',
  zIndex: 1000,
  top: 0,
  left: 0,
})
const dialogStyle = css({
  position: 'absolute',
  zIndex: 1001,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: '#FFFFFF',
  borderRadius: 5,
  '.content-block': {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '40px 70px',
    width: 'max-content',
  },
  '.-text': {
    fontSize: 21,
    fontWeight: 'bold',
    letterSpacing: 1.05,
    color: '#272727',
  },
  '.passport-instruction-block': {
    width: '100%',
    border: 'solid 2px #f2a40b',
    background: '#fffcdd',
    borderRadius: 5,
    margin: 16,
    padding: 16,
    lineHeight: 1.5,
    color: '#7b3306',
    '.title': {
      fontSize: 18,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    '.description': {
      fontSize: 16,
      fontWeight: 'bold',
    },
  },
})
